"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moveEffect = void 0;
var common_1 = require("@timeflies/common");
var tilemap_utils_1 = require("@timeflies/tilemap-utils");
var compute_action_area_1 = require("../compute-action-area");
var pathfinder = tilemap_utils_1.Area.getPathfinderInstance();
var getEmptyEffect = function () { return ({ actionArea: [] }); };
exports.moveEffect = {
    rangeArea: function (position, _a) {
        var charactersPositions = _a.charactersPositions;
        return Object.values(charactersPositions).every(function (pos) { return pos.id !== position.id; });
    },
    effect: function (helper) { return __awaiter(void 0, void 0, void 0, function () {
        var rawActionArea, launcher, turnStartTime, launchTime, turnEndTime, remainingTime, nbrTiles, actionArea, duration, fullActionArea, _a, beforeLastPos, lastPos, orientation;
        var _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0: return [4 /*yield*/, computeActionArea(helper)];
                case 1:
                    rawActionArea = _c.sent();
                    if (rawActionArea.length === 0) {
                        return [2 /*return*/, getEmptyEffect()];
                    }
                    launcher = helper.getLauncher();
                    turnStartTime = helper.params.context.currentTurn.startTime;
                    launchTime = helper.params.partialSpellAction.launchTime;
                    turnEndTime = turnStartTime + launcher.actionTime;
                    remainingTime = turnEndTime - launchTime;
                    nbrTiles = Math.max(Math.min(rawActionArea.length, Math.floor(remainingTime / helper.getDefaultDuration())), 0);
                    if (nbrTiles === 0) {
                        return [2 /*return*/, getEmptyEffect()];
                    }
                    actionArea = rawActionArea.slice(0, nbrTiles);
                    duration = actionArea.length * helper.getDefaultDuration();
                    fullActionArea = __spreadArray([launcher.position], __read(actionArea));
                    _a = __read(fullActionArea.slice(fullActionArea.length - 2), 2), beforeLastPos = _a[0], lastPos = _a[1];
                    orientation = common_1.getOrientationFromTo(beforeLastPos, lastPos);
                    return [2 /*return*/, {
                            duration: duration,
                            actionArea: actionArea,
                            characters: (_b = {},
                                _b[launcher.characterId] = {
                                    position: lastPos,
                                    orientation: orientation
                                },
                                _b),
                        }];
            }
        });
    }); }
};
/**
 * Return move path.
 */
var computeActionArea = function (helper) { return __awaiter(void 0, void 0, void 0, function () {
    var launcher, _a, map, state, path;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                launcher = helper.getLauncher();
                _a = helper.params.context, map = _a.map, state = _a.state;
                if (!compute_action_area_1.isTileInRangeArea(map.rangeArea, helper.targetPos)) {
                    return [2 /*return*/, []];
                }
                return [4 /*yield*/, pathfinder.calculatePath(map.tiledMap, helper.getAllCharacterAliveIdList(), state.characters.position, launcher.position, helper.targetPos)];
            case 1:
                path = _b.sent();
                return [2 /*return*/, path.slice(1)];
        }
    });
}); };
